// Interface

import util from '@/utils/classToObject'
import { IAdministrationState } from './state'

export class AdministrationGetter {

    
    public configuration(state: IAdministrationState) {
        return state.configuration
    }


    //////////////////////////////////////////////////////////////////
    // USER
    /////////////////////////////////////////////////////////////////
    public userStatus(state: IAdministrationState) {
        return state.userStatus
    }
    public userDic(state: IAdministrationState) {
        return state.userDic
    }
    public userList(state:IAdministrationState){
        return state.userList.item.map( id => state.userDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

    //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////
    public mailTemplateStatus(state: IAdministrationState) {
        return state.mailTemplateStatus
    }
    public mailTemplateDic(state: IAdministrationState) {
        return state.mailTemplateDic
    }
    public mailTemplateList(state:IAdministrationState){
        return state.mailTemplateList.item.map( id => state.mailTemplateDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

    //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////
    public mailSkinStatus(state: IAdministrationState) {
        return state.mailSkinStatus
    }
    public mailSkinDic(state: IAdministrationState) {
        return state.mailSkinDic
    }
    public mailSkinList(state:IAdministrationState){
        return state.mailSkinList.item.map( id => state.mailSkinDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    } 

    //////////////////////////////////////////////////////////////////
    // PISCINE
    /////////////////////////////////////////////////////////////////
    public piscineStatus(state: IAdministrationState) {
        return state.piscineStatus
    }
    public piscineDic(state: IAdministrationState) {
        return state.piscineDic
    }
    public piscineList(state:IAdministrationState){
        return state.piscineList.item.map( id => state.piscineDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    } 
    
    //////////////////////////////////////////////////////////////////
    // ACTIVITY
    /////////////////////////////////////////////////////////////////
    public activityStatus(state: IAdministrationState) {
        return state.activityStatus
    }
    public activityDic(state: IAdministrationState) {
        return state.activityDic
    }
    public activityList(state:IAdministrationState){
        return state.activityList.item.map( id => state.activityDic[id] ) //.sort((a,b) => a.libelle.localeCompare(b.libelle) )
    } 

    //////////////////////////////////////////////////////////////////
    // FORFAIT
    /////////////////////////////////////////////////////////////////
    public forfaitStatus(state: IAdministrationState) {
        return state.forfaitStatus
    }
    public forfaitDic(state: IAdministrationState) {
        return state.forfaitDic
    }
    public forfaitList(state:IAdministrationState){
        return state.forfaitList.item.map( id => state.forfaitDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

    //////////////////////////////////////////////////////////////////
    // MNS
    /////////////////////////////////////////////////////////////////
    public mnsStatus(state: IAdministrationState) {
        return state.mnsStatus
    }
    public mnsDic(state: IAdministrationState) {
        return state.mnsDic
    }
    public mnsList(state:IAdministrationState){
        return state.mnsList.item.map( id => state.mnsDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

    //////////////////////////////////////////////////////////////////
    // CONTACT
    /////////////////////////////////////////////////////////////////
    public contactStatus(state: IAdministrationState) {
        return state.contactStatus
    }
    public contactDic(state: IAdministrationState) {
        return state.contactDic
    }
    public contactList(state:IAdministrationState){
        return state.contactList.item.map( id => state.contactDic[id] )
    }  
    public contactMinDate(state:IAdministrationState){
        if(state.contactMinDate && state.contactMinDate != '0001-01-01T00:00:00'){            
            const mindate = new Date(state.contactMinDate)            
            const minYear = new Date().getFullYear() - 50;
            return (mindate.getFullYear() < minYear)?new Date(`${minYear}-01-01`):mindate
        }
        return new Date()
    }  
    
    //////////////////////////////////////////////////////////////////
    // NEWSLETTER
    /////////////////////////////////////////////////////////////////
    public newsletterStatus(state: IAdministrationState) {
        return state.newsletterStatus
    }
    public newsletterDic(state: IAdministrationState) {
        return state.newsletterDic
    }
    public newsletterList(state:IAdministrationState){
        return state.newsletterList.item.map( id => state.newsletterDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

    //////////////////////////////////////////////////////////////////
    // COURS
    /////////////////////////////////////////////////////////////////
    public coursStatus(state: IAdministrationState) {
        return state.coursStatus
    }
    public coursDic(state: IAdministrationState) {
        return state.coursDic
    }
    public coursList(state:IAdministrationState){
        return state.coursList.item.map( id => state.coursDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////
    public commandeStatus(state: IAdministrationState) {
        return state.commandeStatus
    }
    public commandeDic(state: IAdministrationState) {
        return state.commandeDic
    }
    public commandeList(state:IAdministrationState){
        return state.commandeList.item.map( id => state.commandeDic[id] )//.sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }    
    public commandeMinDate(state:IAdministrationState){
        if(state.commandeMinDate && state.commandeMinDate != '0001-01-01T00:00:00'){            
            const mindate = new Date(state.commandeMinDate)            
            const minYear = new Date().getFullYear() - 50;
            return (mindate.getFullYear() < minYear)?new Date(`${minYear}-01-01`):mindate
        }
        return new Date()
    }  

    //////////////////////////////////////////////////////////////////
    // FAMILY
    /////////////////////////////////////////////////////////////////
    public familyStatus(state: IAdministrationState) {
        return state.familyStatus
    }
    public familyDic(state: IAdministrationState) {
        return state.familyDic
    }
    public familyList(state:IAdministrationState){
        return state.familyList.item.map( id => state.familyDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

}

export default util.classToObject(AdministrationGetter)